module.exports = __webpack_public_path__ + "assets/img/goal_p.png?982a3e906a9524f012c677ef0618b2b4";